import {ActionHandlerBase} from "../action-handler-base";
import {ILoginActionPayload} from "@sparkware/uc-sdk-core";

export class LoginActionHandler extends ActionHandlerBase<ILoginActionPayload> {
    async handle(payload: ILoginActionPayload): Promise<void> {
        if(!await this.services.user.ensureUserIsLoggedIn('LoginActionHandler')) {
            throw new Error('User canceled the login');
        }
    }

}